<template>
  <div class="createPage" :style="'height:'+fullHeight+'px;'">
    <!-- header start -->
    <van-nav-bar title="创建纪念馆" class="mynavbar" left-arrow fixed :z-index="99" @click-left="onClickLeft" :border="false">
      <!-- <template #right>
        <van-icon name="share" @click="shareHandler"/> 
      </template> -->
    </van-nav-bar>
    <!-- header end -->

    <img src="@/assets/images/create/step04_bg.jpg" class="createBg">

    <div class="block createSuccess">
      <van-icon name="passed" size="118" color="#fff" />
      <div class="info">创建成功</div>
      <div class="btn-area">
        <van-button block round color="rgba(0,0,0,.25)" :to="{path:'/'}" replace>返回纪念馆</van-button>
        <van-button block round color="rgba(0,0,0,.25)" :to="{path:'/HallInfoEdit', query:{s:1,id:this.uid,}}" replace >完善资料</van-button>
      </div>
    </div>

  </div>
</template>

<script>
  import {Toast} from 'vant'
    export default {
      data() {
        return {
          fullHeight: document.documentElement.clientHeight,
          showNumber:1,
          id : 0,
          uid : null,
          message : null,
        }
      }, 
      methods :{
        onClickLeft() {
          this.$router.go(-1)
        },
        /**推荐给朋友**/
        // shareHandler(){
        //   soshm.popIn({
        //     title: '弹窗分享',
        //     sites: ['weixin', 'weixintimeline', 'weibo', 'qzone', 'tqq', 'qq']
        //   });
        // },
        init(){
          if(!(this.uid)){
            this.$router.push({name:'Home'});
            return;
          }
          if(this.message){
            Toast(this.message);
          }
        }
      },
      created(){
        var that = this;
        this.id = this.$route.params.id;
        this.uid = this.$route.params.uid;
        this.message = this.$route.params.message;
        this.init();
      }
    }
</script>

<style scoped>
.createSuccess{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.createSuccess .info{
  font-size: 34px;
  color: #fff;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 30px;
}
.createPage .btn-area{
  display: flex;
  align-items: center;
  flex-direction: column;
}
.createPage .van-button{
  margin-bottom: 15px;
  border:0 none;
}
</style>
